export type EvidenceUploadingStatusType = 'IN_PROGRESS' | 'FAILED';
export const EvidenceUploadingStatusEnum = {
  InProgress: 'uploading' as EvidenceUploadingStatusType,
  Failed: 'failed' as EvidenceUploadingStatusType,
};
